import { render, staticRenderFns } from "./KrausSmallTooltip.vue?vue&type=template&id=e5e2f5de&lang=pug&"
import script from "./KrausSmallTooltip.vue?vue&type=script&lang=js&"
export * from "./KrausSmallTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports